import '../../styles/restScreens.css';
import React, { useCallback, useEffect, useState } from 'react';
import { supabaseClient } from '../../config/supabase';

const OUTCOMES = ['in_progress', 'escalated', 'auto_confirmed', 'resolved', 'abandoned'];

function CommsGlancePanel({ onOpenCommunications, theme = 'light' }) {
    const dark = theme === 'dark';
    const [sessions, setSessions] = useState([]);
    const [error, setError] = useState(null);

    const loadSessions = useCallback(async () => {
        const since = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString();
        const { data, error: loadError } = await supabaseClient.from('intake_sessions')
            .select('id, channel, itinerary_short_form, outcome, last_inbound_at, created_at')
            .gte('created_at', since)
            .order('last_inbound_at', { ascending: false, nullsFirst: false });
        if (loadError) {
            setError(loadError.message);
            setSessions([]);
        } else {
            setError(null);
            setSessions(data || []);
        }
    }, []);

    useEffect(() => {
        loadSessions();
        const intervalId = setInterval(loadSessions, 30000);
        return () => clearInterval(intervalId);
    }, [loadSessions]);

    const counts = OUTCOMES.reduce((result, outcome) => ({ ...result, [outcome]: sessions.filter((session) => session.outcome === outcome).length }), {});
    const cardCls = dark ? 'bg-gray-800 text-gray-100' : 'bg-white text-gray-900';
    const mutedCls = dark ? 'text-gray-300' : 'text-gray-500';

    return (
        <section data-m6-layout="dashboard" data-m6-component="CommsGlancePanel" className={`rounded-xl shadow-md p-6 ${cardCls}`}>
            <div className="flex items-center justify-between gap-3 mb-4">
                <h2 className="text-xl font-bold flex items-center gap-2"><span>💬</span> Communications</h2>
                <button onClick={onOpenCommunications} className="text-sm font-medium text-[var(--accent-ink)] hover:text-[var(--accent-ink-hover)]">Open workspace →</button>
            </div>
            {error ? <p className="text-sm text-red-600">Could not load communications: {error}</p> : <>
                <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 mb-4">
                    {OUTCOMES.map((outcome) => <div key={outcome} className={`rounded-lg p-2 text-center ${dark ? 'bg-gray-700' : 'bg-gray-50'}`}><div className="text-lg font-bold">{counts[outcome]}</div><div className={`text-xs capitalize ${mutedCls}`}>{outcome.replace(/_/g, ' ')}</div></div>)}
                </div>
                {sessions.length === 0 ? <div className={`text-center py-4 ${mutedCls}`}>No communications in the last 30 days</div>
                    : <div className="space-y-2">{sessions.slice(0, 5).map((session) => <div key={session.id} className={`flex justify-between gap-3 py-2 border-b last:border-0 ${dark ? 'border-gray-700' : 'border-gray-100'}`}><div className="min-w-0"><div className="font-semibold capitalize">{session.channel}</div><div className={`text-sm truncate ${mutedCls}`}>{session.itinerary_short_form || 'Intake session'}</div></div><div className={`text-xs text-right whitespace-nowrap ${mutedCls}`}>{session.last_inbound_at ? new Date(session.last_inbound_at).toLocaleString() : new Date(session.created_at).toLocaleString()}</div></div>)}</div>}
            </>}
        </section>
    );
}

export default CommsGlancePanel;
